import { Pagination as AntPagination } from "antd";

const Pagination = ({
  currentPage,
  currentPageSize,
  totalCount,
  loading = false,
  onChange,
}) => {
  return (
    <>
      <AntPagination
        current={currentPage}
        pageSize={currentPageSize}
        total={totalCount}
        disabled={loading}
        onChange={onChange}
        simple={true}
        showSizeChanger={true}
        showTotal={(total) => `Total ${total} items`}
      />
    </>
  );
};

export default Pagination;
